class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.mainDetailsToggle.querySelector('summary');

    // Desktop mouse: open on hover, close shortly after leaving (the delay bridges the gap to the
    // panel). Touch and keyboard keep the click/Enter toggle.
    this.canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
    this.addEventListener('pointerenter', this.onPointerEnter.bind(this));
    this.addEventListener('pointerleave', this.onPointerLeave.bind(this));
    this.summary.addEventListener('click', this.onSummaryClick.bind(this));
  }

  onPointerEnter(event) {
    if (event.pointerType !== 'mouse' || !this.canHover.matches) return;
    clearTimeout(this.hoverTimer);
    if (this.mainDetailsToggle.open) return;
    this.hoverTimer = setTimeout(() => this.open(), 80);
  }

  onPointerLeave(event) {
    if (event.pointerType !== 'mouse' || !this.canHover.matches) return;
    clearTimeout(this.hoverTimer);
    if (!this.openedByHover) return;
    this.hoverTimer = setTimeout(() => this.close(), 250);
  }

  // A mouse click on a menu that hover already opened goes to the category itself instead of closing it.
  onSummaryClick(event) {
    if (!this.openedByHover || event.detail === 0) return;
    event.preventDefault();
    const href = this.summary.dataset.href;
    if (href) window.location.href = href;
  }

  open() {
    document.querySelectorAll('header-menu').forEach((menu) => menu !== this && menu.close());
    this.openedByHover = true;
    this.mainDetailsToggle.setAttribute('open', '');
    this.summary.setAttribute('aria-expanded', true);
  }

  close() {
    this.openedByHover = false;
    super.close();
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
